export const IDLE = 'idle';
export const PENDING = 'pending';
export const SUCCESS = 'success';
export const FAILURE = 'failure';

export const VERSION_NO = '1.1.0';

export const MOBILE_SIZE = 575;
export const TABLET_SIZE = 900;
export const DESKTOP_SIZE = 1280;

export const MAX_CHAR_LENGTH = 255;
export const WINDOWS_RESIZE_MS = 500;
export const QUICK_WINDOWS_RESIZE_MS = 100;

export const TABLE_PAGE_SIZE = 10;
export const SCREEN_TYPE = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
  HD: 'hd',
};

export const SCREEN_SIZE = {
  md: '480px',
  lg: '900px',
  xl: '1200px',
};

export const TEMP = {
  HIGH: 'High',
  NORMAL: 'Normal',
  NONE: 'N/A',
};

export const TYPE = {
  LOADING: 'loading',
  ADD: 'add',
  EDIT: 'edit',
};

export const TEMPERATURE_THRESHOLD = 37.5;
